import type { AxiosError, AxiosInstance } from 'axios';

/**
 * Shared response interceptor that replaces the default Axios error message
 * with a custom error_message from the API response when available.
 */
export const applyCustomErrorInterceptor = (client: AxiosInstance) => {
  client.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response && error.response.data) {
        // @ts-expect-error we don't know the type, but we check each object
        const customMessage = error.response.data?.errors?.[0]?.error_message;

        if (customMessage) {
          error.message = customMessage;
        }
      }

      return Promise.reject(error);
    }
  );
};
